<template>
    <div v-if="context !== null && context.customer != null" class="primary">
        <d-site
            v-model    = "siteDialog"
            :site-id   = "siteId"
            :tab-index = "siteTabIndex"
            @close     = "siteTabIndex = 0"
            @customer  = "onCustomer"
        />

        <v-row class="no-frame">
            <v-col class="no-frame col-6 v-flex">
                <c-site-title
                    :site      = "context"
                    :hide-type = "true"
                    class      = "mr-3"
                    style      = "margin-top: -5px"
                />

                <div
                    class = "v-flex"
                    style = "margin-top: -3px"
                >
                    <div class="v-flex">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on: tooltip }">
                                <a
                                    v-on   = "{ ...tooltip }"
                                    @click.prevent="onEdit"
                                >
                                    <v-icon color="white" :class="stops ? 'red' : ''" size="23">{{ context.type.symbol }}</v-icon>
                                </a>
                            </template>
                            <div>
                                <div style="text-align: center">
                                    {{ $t("unit.menu.siteedit") }}
                                </div>
                                <div v-if="stops" class="red pl-3 pr-2 pt-1 pb-1 mt-2" style="border-radius: 10px;">
                                    Die Anlage hat {{ stops }} Stockwerke
                                </div>
                            </div>
                        </v-tooltip>

                        <v-tooltip bottom v-if="liftmanager">
                            <template v-slot:activator="{ on: tooltip }">
                                <a
                                    v-on   = "{ ...tooltip }"
                                    @click.prevent="onIncidents"
                                >
                                    <v-icon color="white" size="25">mdi-format-list-bulleted</v-icon>
                                </a>
                            </template>
                            <span>{{ $t("unit.menu.incidents") }}</span>
                        </v-tooltip>

                        <c-site-liftguardian
                            class="ml-3"
                            :context = "context"
                        />
                    </div>
                </div>

                <v-spacer/>
                <c-inc-navigation />
            </v-col>
            <v-col class="no-frame col-3">
                <c-inc-maintenance-state
                    :site    = "context"
                    @details = "onSiteDialog(9)"
                />
            </v-col>

            <v-col class="no-frame col-3" >
                <c-site-title-row-assessment
                    :site    = "context"
                    @details = "onSiteDialog(10)"
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>

import Core                    from "@/modules/core/service/Core";
import Site                    from "@/modules/msd/unit/service/Site";
import CIncMaintenanceState    from "@/modules/inc/maintenance/CIncMaintenanceState";
import CSiteTitleRowAssessment from "@/modules/msd/unit/components/top/CSiteTitleRowAssessment";
import DSite                   from "@/modules/msd/unit/components/dialog/DSite";
import CSiteTitle              from "@/modules/msd/unit/components/controlls/CSiteTitle";
import CIncNavigation          from "@/modules/inc/steps/components/navigation/CIncNavigation.vue";
import CSiteLiftguardian       from "@/modules/datahub/components/CSiteLiftguardian.vue";

export default {
    name: "CSiteTitleRow",

    components: {
        CSiteLiftguardian,
        CIncNavigation,
        CSiteTitle,
        DSite,
        CSiteTitleRowAssessment,
        CIncMaintenanceState,
    },

    props: {
        context: {
            required: true,
            type    : Object,
            default : function () {
                return null;
            }
        },
    },

    data: () => ({
        siteId: null,
        siteDialog: false,
        siteTabIndex: 0,
        menu: false,
    }),

    computed: {
        liftmanager() {
            return Core.role.liftmanager();
        },

        site () {
            return this.$store.getters.site;
        },

        stops () {
            if (!this.context || !this.context.specification || !this.context.specification.stops) {
                return null;
            }

            const stopAlert = this.context.customer.stopsAlert ? this.context.customer.stopsAlert : 9;
            if (this.context.specification.stops < stopAlert) {
                return null;
            }

            return this.context.specification.stops;
        }
    },

    methods: {
        onEdit (event) {
            event.stopPropagation();
            this.siteId = this.context.id;
            this.siteDialog = true;
        },

        onIncidents (event) {
            event.stopPropagation();
            Site.goto(this, this.context.id);
        },

        onCustomer () {
            this.$emit("customer");
        },

        onWarrenty (event) {
            event.stopPropagation();
        },

        onSiteDialog (index) {
            this.siteId = this.context.id;
            this.siteDialog = true;
            this.siteTabIndex = index;
        }
    }
}
</script>

